import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Target, PenTool, MessageSquare, DollarSign, Calendar, Gift } from 'lucide-react';
export function Contents() {
  return <Section className="bg-white" data-id="element-91">
      <div className="text-center mb-12" data-id="element-92">
        <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-93">
          ✅ Qué incluye Mamá Digital 2.0
        </h2>
        <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-94">
          Piensa en esto como: tu guía + tu plan + tus prompts para crear y
          vender tu primer producto digital.
        </p>
      </div>

      <div className="max-w-5xl mx-auto mb-12" data-id="element-95">
        <img src="https://cdn.magicpatterns.com/uploads/kTpbPJ8qdeYZyuJU8TJZeK/heylloyd-image-1768698487050.png" alt="Vista previa del contenido de Mamá Digital 2.0" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-96" />
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-97">
        <div className="overflow-x-auto" data-id="element-98">
          <table className="w-full text-left border-collapse" data-id="element-99">
            <thead data-id="element-100">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-101">
                <th className="p-4 font-bold text-gray-900" data-id="element-102">Módulo</th>
                <th className="p-4 font-bold text-gray-900 hidden md:table-cell" data-id="element-103">
                  Lo que logras
                </th>
                <th className="p-4 font-bold text-gray-900" data-id="element-104">Resultado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-105">
              {[{
              mod: 'Capítulo 1: Sí puedes crear un PDF vendible',
              what: 'Entiendes por qué tu celular es suficiente',
              res: 'Empiezas con confianza'
            }, {
              mod: 'Capítulo 2: Mentalidad Mamá Digital 2.0',
              what: 'Rompes creencias limitantes',
              res: 'Te desbloqueas'
            }, {
              mod: 'Capítulo 3: Detecta tu tema ganador',
              what: 'Usas el método 3P + prompts de Heylloyd',
              res: 'Eliges idea con demanda'
            }, {
              mod: 'Capítulo 4: Estructura fácil del PDF',
              what: 'Heylloyd te entrega capítulos y bullets',
              res: 'Tu PDF deja de ser "un caos"'
            }, {
              mod: 'Capítulo 5: Crea tu PDF con Gamma',
              what: 'Lo conviertes en un PDF profesional',
              res: 'Producto listo para vender'
            }, {
              mod: 'Plan de acción 7 días',
              what: 'Día por día, qué hacer y qué publicar',
              res: 'Pasas de idea → ventas'
            }].map((row, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-106">
                  <td className="p-4 text-gray-900 font-medium" data-id="element-107">{row.mod}</td>
                  <td className="p-4 text-gray-600 hidden md:table-cell" data-id="element-108">
                    {row.what}
                  </td>
                  <td className="p-4 text-brand-pink font-bold" data-id="element-109">{row.res}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </Section>;
}